import React, { useEffect, useState } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import EstudiantesTableC from "./EstudiantesTableC";
import { BusquedaEst } from "../../funciones/EstudiantesFunction";

const EstudianteConsult = (props) => {
    const [string, setString] = useState("");
    const [preloader, setPreloader] = useState("");
    const [estudiantes, setEstudiantes] = useState([]);
    const [textTabla, setTextTabla] = useState("Ingresa una cédula, nombre o apellido para consultar");
    const [openW, setOpenW] = useState(false);
    const [idEst, setIdEst] = useState("");
    const [nEst, setNEst] = useState("");
    const [estData, setEstData] = useState("");
    const [control, setControl] = useState(false);


    let enterTab = () => (e) => {
        if (e.which === 13){
            if (string === "") return null;
            setPreloader("fa fa-spinner fa-spin")

            BusquedaEst (string, (resp) => {
                if (resp.length === 0) {
                    toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                    setPreloader("")
                    setTextTabla("La búsqueda no obtuvo resultados")
                    setEstudiantes([])
                }else{
                    setPreloader("")
                    setEstudiantes(resp)
                }
            })
        }
    }

    let consultaEst = () => {
        BusquedaEst (string, (resp) => {
            if (resp.length === 0) {
                toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                setPreloader("")
                setTextTabla("La búsqueda no obtuvo resultados")
                setEstudiantes([])
            }else{
                setPreloader("")
                setEstudiantes(resp)
            }
        })
    }


    let showModal = () => {

    }

    let openModal = (data, nombre) => {
        setOpenW(true)
        setEstData(data)
        setNEst(nombre)
        setControl(false)
    }

    let ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                El módulo Opciones Estudiantes permite la consulta de materias de la oferta académica de cualquier estudiante. Para esto debes realizar los siguientes pasos:
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
            </Col>
            <Col md={12} align="justify">
                Ingresa un dato del estudiante a consultar (cédula, nombre o apellido).
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Verás un listado con todas las coincidencias de tu búsqueda con los siguientes datos:
            </Col>
            <Col md={12} align="justify" className="custom-mt-10" style={{paddingLeft:30, paddingRight:30, fontSize: 10}}>
                <div><strong>C.I.</strong> Cédula del Estudiante</div>
                <div><strong>Estudiante</strong> Nombres y Apellidos</div>
                <div><strong>Carrera</strong> Carrera Inscrita</div>
                <div><strong>Acciones</strong> Botón de Acciones</div>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
            </Col>
            <Col md={12} align="justify">
                Una vez seleccionado el estudiante presiona el botón <button className="btn btn-xs btn-primary" style={{borderWidth:1}}><i className="fa fa-mail-forward"></i> Acciones</button> el cual te abrirá una ventana con las opciones de la inscripción.
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                En la ventana que se abrirá podrás ver la ayuda en la parte superior izquierda haciendo click en el botón <button className="btn btn-xs btn-warning" style={{borderWidth:1}}><i className="fa fa-question-circle-o"></i></button>
            </Col>
        </Row>
    )

    const styles = {
        padding: 5, fontSize: 12
    }

    let lisEstudiantes = () => {
        if(estudiantes.length === 0) {
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }else if(estudiantes.length > 0) {
            return (
                estudiantes.map(option => (
                    <EstudiantesTableC
                        key={option.id_estudiante}
                        data={option}
                        verDatos = {(data, nombre) => {openModal(data, nombre)}}
                        boton = ""
                        consulta = {() => {consultaEst()}}
                    />
                ))
            )
        }else{
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }
    }

    return (
        <div className="content">
            <Row>
                <Col md={8}>
                    <div className="custom-alert-success" style={{padding: 5}}>
                        <div>Búsqueda de Estudiantes <i className={preloader}></i></div>
                        <input type="text" value ={string} onChange={(e) => {setString(e.target.value)}} onKeyPress={enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                    </div>
                    <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                    <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                    <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {lisEstudiantes()}
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col md={4}>
                    <div style={{borderRadius: "4px 4px",}}>
                        <CustomCard
                            styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                            title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                            category={<span style={{color: "#fff"}}>Estudiantes</span>}
                            color="#a80012"
                            content={ayuda()}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default EstudianteConsult;


// WEBPACK FOOTER //
// ./src/views/Consultas/EstudianteConsult.jsx